import MetricViewContainer from "./MetricView";

export { MetricViewContainer };



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/index.ts